import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import * as moment from 'moment';
import 'moment-duration-format';
import {TranslateService} from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  public examTimerString: any = "";
  public extraTimeString: any = "";
  public adaptedTimeString: any = "";
  public showExtraTime = false;
  public showAdaptedTime = false;
  public useTimer = false;
  public useQuestionTimer = false;
  public timerInterval;
  public timerTimeout;
  public movingToQuestion = 0;
  public isLoaded = false;
  public canShowQuestions = false;
  public showExamCompleteMsg = false;

  private _loadInterval = null;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    private  domSanitizer: DomSanitizer,
    public modalService: ModalService
  ) {
    // Only show if not eproctoring exam or if loaded through wrapper
    let eproctEnabled = false;
    if(this.dataSvc.currentExamIndex > -1) {
      eproctEnabled = this.dataSvc.currentExam.Session.EnableEProctoring;
    }
    var urlParams = new URLSearchParams(window.location.search);
    var eproctored = urlParams.get('eproctored');
    let eproctLoaded = eproctored == "1";
    this.canShowQuestions = !eproctEnabled || (eproctEnabled && eproctLoaded);
    
    let scheduleId = this.dataSvc.getParameterByName("scheduleId");
    let candidateId = this.dataSvc.getParameterByName("candidateId");
    let username = this.dataSvc.getParameterByName("username");
    
    if(eproctLoaded && scheduleId !== null && scheduleId !== "" && candidateId !== null && candidateId !== "" && username !== null && username !== ""){
      this._loadInterval = setInterval( () => {
        if(!this.dataSvc.syncingConfig) {
          this.dataSvc.initDataDownload(username, scheduleId, candidateId, false).then(() => {
            var scheduleCandidate = this.dataSvc.scheduleCandidates.filter(x => x.CandidateId == candidateId && x.ScheduleId == scheduleId)[0];
            if (scheduleCandidate != null) {
              this.dataSvc.packageData(scheduleCandidate, "");
            }
            this.dataSvc.setCurrentExam(0);
            this.dataSvc.setCurrentAssessment();
            this.dataSvc.setCurrentQuestion();
            this.loadData();
            this.onInit();
          });
          clearInterval(this._loadInterval);
        }
      }, 2000);
    } else {
      if (eproctLoaded) {
        this.dataSvc.showLoading("Reloading exam data...");
        this._loadInterval = setInterval( () => {
          if(!this.dataSvc.syncingConfig){
            this.dataSvc.attemptLoginLocally();
            this.loadData();
            this.onInit();
            clearInterval(this._loadInterval);
          }
        }, 2000);
      } else {
        this.loadData();
      }
    }

    
  }

  ngOnInit() {
    if (!(this.dataSvc.getParameterByName("eproctored") == "1")) {      
      this.onInit();
    }
  }

  onInit() {
    if(this.dataSvc.currentExam.Session.AssessmentTime > 0){
      this.initiateTimer();
      this.useTimer = true;
    }else{
      this.useTimer = false;
    }
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    this.isLoaded = true;
    window.parent.postMessage('exam-start', '*');
  }

  loadData() {
    if (this.dataSvc.currentUser.ScheduleCandidate == null || this.dataSvc.currentUser.Exams.length == 0){
      var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
      this.generalSvc.logoutUser(enetsecure);
    }

    if (this.dataSvc.currentExamIndex == -1)
    this.generalSvc.loginUser();

    // find first un-answered question;
    var i = 0;
    var qfound = false;
    this.dataSvc.currentExam.Questions.forEach(question => {
      if (question.Disabled != true && !qfound){
        this.dataSvc.setQuestion(i);
        qfound = true;
      }
      i++;
    });

    if (!qfound)
    this.dataSvc.setQuestion(i);
  }

  

  initiateTimer(){
    this.restorePersistedTimeTaken();

    var questionTimerMode = this.dataSvc.currentExam.Session.UseQuestionTime;
    if(questionTimerMode){
      //use time from questions
      this.useQuestionTimer = true;
      var qtimerMins = 0;
      var questions = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Questions;
      for(var q = 0; q < questions.length; q++){
        var question = questions[q].Question;
        if(question != null){
          var qTime = question.QuestionTime;
          if(qTime !== null){
            qtimerMins += qTime;
          }
        }
      }
  
      var adaptedTimeSeconds = 0;
      var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
      if(scheduleCandidate != null){
        if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
          adaptedTimeSeconds = Number(scheduleCandidate.ExtraTime) || 0;
        }
      }
  
      var seconds = (qtimerMins * 60) + adaptedTimeSeconds;
      var checkTime = seconds - this.dataSvc.currentExam.Session.Timetaken;
      var enableFlexibleTimer = this.dataSvc.currentExam.Session.AssessmentEnableExtraTime;
      if(checkTime <= 0){
        if(enableFlexibleTimer){
          this.dataSvc.currentQuestion.Question.ExtraTimeUsed = (checkTime * -1)
        }
      }
      else{
        this.startQuestionTimer(checkTime);
      }
    }
    else{
      //use time from exam
      this.useQuestionTimer = false;
      var timerMins = Number(this.dataSvc.currentExam.Session.AssessmentTime) || 0;
    var adaptedTimeSeconds = 0;
    var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
    if(scheduleCandidate != null){
      if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
        adaptedTimeSeconds = Number(scheduleCandidate.ExtraTime) || 0;
      }
    }

    var seconds = (timerMins * 60) + adaptedTimeSeconds;
    var checkTime = seconds - this.dataSvc.currentExam.Session.Timetaken;
    var enableFlexibleTimer = this.dataSvc.currentExam.Session.AssessmentEnableExtraTime;  
    if(this.dataSvc.demoExam){
      this.startTimer(this.dataSvc.currentExam.Session.AssessmentTime * 60);
    }
    else{
      if(checkTime <= 0 && !enableFlexibleTimer){
          clearInterval(this.dataSvc.interval);
          this.dataSvc.EndExam();
        }
        else{
          this.startTimer(checkTime);
        }
    }
    }   
  }

  private restorePersistedTimeTaken() {
    var session = this.dataSvc.currentExam.Session;
    var persistedTimeTaken = Number(session.Timetaken) || Number(session.TimeTakenInSeconds) || 0;
    var localTimeTaken = Number(localStorage.getItem(this.getTimeTakenStorageKey())) || 0;

    var sessionQuestionTime = (this.dataSvc.currentExam.SessionQuestions || [])
      .reduce((total, question) => total + (Number(question.TimeSpentMins) || 0), 0);

    var resultTime = (this.dataSvc.currentExam.Questions || [])
      .reduce((total, question) => total + (Number(question.TimeSpent) || 0), 0);

    session.Timetaken = Math.max(persistedTimeTaken, localTimeTaken, sessionQuestionTime, resultTime);
    this.persistTimeTaken();
  }

  private incrementTimeTaken() {
    this.dataSvc.currentExam.Session.Timetaken =
      (Number(this.dataSvc.currentExam.Session.Timetaken) || 0) + 1;
    this.persistTimeTaken();
  }

  private persistTimeTaken() {
    localStorage.setItem(
      this.getTimeTakenStorageKey(),
      (Number(this.dataSvc.currentExam.Session.Timetaken) || 0).toString());
  }

  private getTimeTakenStorageKey(): string {
    return "examTimeTaken_" + this.dataSvc.currentExam.Session.SessionId;
  }

    startTimer(duration){
      this.dataSvc.currentExam.Session.timer = duration;
      //timer = 15;
      clearInterval(this.dataSvc.interval);
      this.dataSvc.interval = setInterval(() => {
        if (this.dataSvc.isConnected) {          
          var enableFlexibleTimer = this.dataSvc.currentExam.Session.AssessmentEnableExtraTime; 
          //STANDARD ENETASSESS TIMER LOGIC
          this.dataSvc.currentExam.Session.minutes = parseInt(this.dataSvc.currentExam.Session.timer) / 60;
          this.dataSvc.currentExam.Session.seconds = parseInt(this.dataSvc.currentExam.Session.timer) % 60;

          this.dataSvc.currentExam.Session.minutes = this.dataSvc.currentExam.Session.minutes < 10 ? "0" + this.dataSvc.currentExam.Session.minutes : this.dataSvc.currentExam.Session.minutes;
          this.dataSvc.currentExam.Session.seconds = this.dataSvc.currentExam.Session.seconds < 10 ? "0" + this.dataSvc.currentExam.Session.seconds : this.dataSvc.currentExam.Session.seconds;
          var pat = /\b(900)\b/g;
          if (--this.dataSvc.currentExam.Session.timer < 0) {
            if(enableFlexibleTimer){
              clearInterval(this.dataSvc.interval);
              this.startStandardExtraTimer();
              document.getElementById("timerStrPara").style.display = "none";          
            }
            else{
              this.dataSvc.currentExam.Session.timer = 0;
              alert("Exam Finished");
              clearInterval(this.dataSvc.interval);
              this.dataSvc.EndExam();
              this.dataSvc.currentQuestion.Question.ExtraTimeUsed = (this.dataSvc.currentExam.Session.timer * -1)
            }            
          }
          else if(this.dataSvc.currentExam.Session.timer == 900 || this.dataSvc.currentExam.Session.timer.toString().match(pat)){
            document.getElementById("btnOpenTimer").click();
          }
          
          this.dataSvc.currentExam.Session.seconds = this.dataSvc.currentExam.Session.timer;
          this.dataSvc.currentExam.Session.duration = moment.duration(this.dataSvc.currentExam.Session.seconds, 'seconds');          
          this.examTimerString = this.dataSvc.currentExam.Session.duration.format("hh:mm:ss");

          // construct exam time taken;
          this.incrementTimeTaken();

          // set time spent on question;
          if (this.dataSvc.currentQuestion.Question.TimeSpent == null || this.dataSvc.currentQuestion.Question.TimeSpent == undefined)
            this.dataSvc.currentQuestion.Question.TimeSpent = 0;

          this.dataSvc.currentQuestion.Question.TimeSpent++;
        }
      }, 1000);
  }
  

  startQuestionTimer(duration){
      this.dataSvc.currentExam.Session.timer = duration;
      //timer = 15;
      clearInterval(this.dataSvc.interval);
      this.dataSvc.interval = setInterval(() => {
        if (this.dataSvc.isConnected) {

          //check to see if task time has elapsed
          
          var task = this.dataSvc.taskQuestion(this.dataSvc.currentQuestion.Question.Question.QuestionID);
          if(task !== null){
            if(task.Percentage >= 100){              
              var adaptedTime = this.dataSvc.currentUser.ScheduleCandidate.ExtraTime;
              if(adaptedTime !== null && adaptedTime !== undefined && adaptedTime !== 0){
                this.dataSvc.currentUser.ScheduleCandidate.ExtraTime -= 1;
                this.dataSvc.currentQuestion.SessionQuestion.AdapatedTimeSpentMins += 1;
                this.showAdaptedTime = true;
                this.adaptedTimeString = moment.duration(this.dataSvc.currentUser.ScheduleCandidate.ExtraTime, 'seconds').format("hh:mm:ss");
              }
              else{
                this.startExtraTimeTimer();
                this.showAdaptedTime = false;
                this.adaptedTimeString = "";
              }
            }
            else{
              this.showAdaptedTime = false;
              this.adaptedTimeString = "";
              this.showExtraTime = false;
              this.examTimerString = "";
              this.dataSvc.currentQuestion.SessionQuestion.TimeSpentMins += 1;
              this.dataSvc.getTaskQuestionTimeUsed();
            }
          }
          // construct exam time taken;
          this.incrementTimeTaken();

          // set time spent on question;
          if (this.dataSvc.currentQuestion.Question.TimeSpent == null || this.dataSvc.currentQuestion.Question.TimeSpent == undefined)
            this.dataSvc.currentQuestion.Question.TimeSpent = 0;

          this.dataSvc.currentQuestion.Question.TimeSpent ++;
        }
      }, 1000);
  }

  startStandardExtraTimer(){
    this.dataSvc.currentExam.Session.ExtraTimetaken = 1;
    this.dataSvc.interval = setInterval(() => {
      if(this.dataSvc.currentExam.Session.AssessmentEnableExtraTime){
        this.incrementTimeTaken();
        var currentExtraTime = this.dataSvc.currentExam.Session.ExtraTimetaken;
        this.dataSvc.currentQuestion.SessionQuestion.ExtraTimeSpentMins += 1;         
        if(currentExtraTime !== null && currentExtraTime > 0){
          this.showExtraTime = true;          
          this.extraTimeString = moment.duration(currentExtraTime, 'seconds').format("hh:mm:ss");
          this.dataSvc.currentExam.Session.ExtraTimetaken++;
        }
      }
    },1000);
  }

  startExtraTimeTimer(){

    if(this.dataSvc.currentExam.Session.AssessmentEnableExtraTime){
      this.dataSvc.currentQuestion.SessionQuestion.ExtraTimeSpentMins += 1;
        var taskExtraTime = this.dataSvc.checkTaskForExtraTimeUsed(this.dataSvc.currentQuestion.Question.Question.QuestionID);
        if(taskExtraTime !== null && taskExtraTime > 0){
          this.showExtraTime = true;          
          this.extraTimeString = moment.duration(taskExtraTime, 'seconds').format("hh:mm:ss");
        }
        else{
          this.showExtraTime = false;
          this.extraTimeString = "";
        }
    }
    else{
      //console.log(this.dataSvc.currentExam);
      var timeRemainingQuestions = this.dataSvc.currentExam.Tasks.filter(x => x.TimeUsed < x.Timer);
      
      if(timeRemainingQuestions !== null && timeRemainingQuestions !== undefined){
        if(timeRemainingQuestions.length > 0){
          var questionId = timeRemainingQuestions[0].QuestionIds.split(',')[0];
          var questionIndex = 0;
          this.dataSvc.currentExam.SessionQuestions.forEach(question => {
            if (question.QuestionId.toString() === questionId){
              this.movingToQuestion = (questionIndex + 1);              
              this.dataSvc.showTimerAlert = true;
              this.dataSvc.showTimerAlertCounter = 5;
              clearInterval(this.timerInterval);
                this.timerInterval = setInterval(() => { 
                  this.dataSvc.showTimerAlertCounter += -1; 
              }, 1000);

              clearTimeout(this.timerTimeout);
              this.timerTimeout = setTimeout(() => { 
                  this.dataSvc.showTimerAlert = false; 
                  clearInterval(this.timerInterval);
              }, 6000);
              this.dataSvc.setQuestion(questionIndex);
            }
            questionIndex++;
          });
        }   
        else{
          alert("There is no time remaining on any of the questions. Your exam has now finished.");
          this.dataSvc.EndExam();
        }     
      }
      else{
        alert("There is no time remaining on any of the questions. Your exam has now finished.");
        this.dataSvc.EndExam();
      }
    }        
  }

  isExamTimeFinished(endTime, startTime, allottedTime){
    var now = moment().format();
    var end = moment(endTime).format();
    if(now >= end){
      //clearInterval(this.dataSvc.interval);
      //this.dataSvc.EndExam();
    }
    else{
      var start = moment(startTime).format();
      var difference = moment.duration(moment().diff(moment(start))).as('minutes');
      var minutes = difference;
      var allowedtime = (parseInt(allottedTime) * 60);
      var correctTime = allowedtime - (minutes * 60);
      return correctTime;
    }
  }

  getStyles(){
    var css = this.dataSvc.currentExam.Session.AssessmentThemeCss;
    if(css !== null && css !== undefined && css !== ""){
      var cssStr = "<style>" + css + "</style>";
      return this.domSanitizer.bypassSecurityTrustHtml(cssStr);
    }
  }

  isNumeric(str: string) {
    return !isNaN(parseInt(str))
  }

  markCompleted() {
    this.showExamCompleteMsg = true;
  }

  increaseFont(): void {
    const currentFontSize = this.getCurrentFontSize();
    if (currentFontSize <= 22) {
      this.applyFontSize(currentFontSize + 2);
    }
  }

  decreaseFont(): void {
    const currentFontSize = this.getCurrentFontSize();
    if (currentFontSize >= 14) {
      this.applyFontSize(currentFontSize - 2);
    }
  }

  toggleBoldFont(): void {
    const boldField = document.getElementById("hfBold") as HTMLInputElement;
    const shouldBold = boldField == null || boldField.value !== "1";

    this.applyBoldFont(shouldBold);
  }

  private getCurrentFontSize(): number {
    const fontSizeField = document.getElementById("hfFontSize") as HTMLInputElement;
    const value = fontSizeField == null ? "" : fontSizeField.value.replace("px", "");
    const currentFontSize = parseInt(value, 10);

    return isNaN(currentFontSize) ? 14 : currentFontSize;
  }

  private applyFontSize(fontSize: number): void {
    const container = document.getElementById("container");
    const fontSizeField = document.getElementById("hfFontSize") as HTMLInputElement;

    if (container != null) {
      container.classList.add("exam-font-adjusted");
      container.style.setProperty("--exam-font-size", fontSize + "px");
      container.style.setProperty("font-size", fontSize + "px", "important");
    }

    if (fontSizeField != null) {
      fontSizeField.value = fontSize + "px";
    }

    this.applyToEditors((body) => body.setStyle("font-size", fontSize + "px"));
  }

  private applyBoldFont(shouldBold: boolean): void {
    const container = document.getElementById("container");
    const boldField = document.getElementById("hfBold") as HTMLInputElement;
    const fontWeight = shouldBold ? "bold" : "";

    if (container != null) {
      if (shouldBold) {
        container.classList.add("force-bold");
      } else {
        container.classList.remove("force-bold");
      }
    }

    if (boldField != null) {
      boldField.value = shouldBold ? "1" : "0";
    }

    this.applyToEditors((body) => body.setStyle("font-weight", fontWeight));
  }

  private applyToEditors(applyStyle: (body: any) => void): void {
    const ckeditor = (window as any).CKEDITOR;

    if (ckeditor == null || ckeditor.instances == null) {
      return;
    }

    for (const editor in ckeditor.instances) {
      if (ckeditor.instances.hasOwnProperty(editor)) {
        const instance = ckeditor.instances[editor];
        const body = instance != null && instance.document != null && instance.document.getBody != null
          ? instance.document.getBody()
          : null;
        if (body != null) {
          applyStyle(body);
        }
      }
    }
  }
  
}
